export default {
  state:{
    example:'min'
  }, 
  mutations:{
    example(state){
       console.log(state,'min**88**')
    }
  }
}